import React from "react";
import "./styles/ItDecarbonizationContent.scss";
import BannerType1 from "./BannerType1";
import { useTranslation } from "react-i18next";
const ItDecarbonizationContent = () => {
  const { t } = useTranslation();
  const contents = t("it.decarbonization.solution.contents", { returnObjects: true }) as {
    name: string;
    list: string[];
  }[];
  return (
    <>
      <div className="it_decarbonization_content_wrap">
        <BannerType1 path="/imgs/banner_it_decarbonization.png" />
        <h2 className="title">{t("it.decarbonization.solution.title")}</h2>
        <div className="contents">
          <div className="des">{t("it.decarbonization.solution.des")}</div>
          <div className="card_wrap">
            {contents.map((content: { name: string; list: string[] }, index: number) => {
              return (
                <div className="card" key={`${content.name}_${index}`}>
                  <div className="name">{content.name}</div>
                  <ul>
                    {content.list.map((text: string, index: number) => {
                      return <li key={`${text}_${index}`}>{text}</li>;
                    })}
                  </ul>
                </div>
              );
            })}
          </div>
          <div className="des">{t("it.decarbonization.solution.ment")}</div>
        </div>
      </div>
    </>
  );
};

export default ItDecarbonizationContent;
